var _circle, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#4C1DB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3952 25.1277C29.1707 25.1277 27.9684 24.9362 26.8291 24.5597C26.2708 24.3693 25.5845 24.544 25.2438 24.8939L22.995 26.5915C20.387 25.1994 18.7806 23.5934 17.4074 21.0051L19.0551 18.8148C19.4832 18.3873 19.6367 17.7629 19.4528 17.1769C19.0746 16.0316 18.8826 14.8299 18.8826 13.6049C18.8826 12.7199 18.1627 12 17.2778 12H13.6048C12.7199 12 12 12.7199 12 13.6048C12 23.7481 20.252 32 30.3952 32C31.2801 32 32.0001 31.2801 32.0001 30.3952V26.7325C32 25.8477 31.2801 25.1277 30.3952 25.1277Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneIcon.ec1d76b0.svg";
export { ForwardRef as ReactComponent };